<template>
    <section class="faq">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <script v-if="hasJsonLd" v-html="jsonLD" type="application/ld+json" />
        <div class="container">
            <h1 v-if="heading && headingTag === 'h1'" class="section-heading" :class="{'seo-only': hasSeoOnly}">
                {{ heading }}
            </h1>
            <h2 v-else-if="heading" class="section-heading" :class="{'seo-only': hasSeoOnly}">
                {{ heading }}
            </h2>
            <ul
                aria-multiselectable="true"
                class="list-unstyled mb-0"
                id="accordion"
                role="tablist"
            >
                <question v-for="(item, i) in items" :key="i" :item="item" />
            </ul>
        </div>
    </section>
</template>

<script>
import Question from '~/components/pages/landing/faq/question';

export default {
    components: {
        Question,
    },
    props: {
        items: {
            type: Array,
            default: () => ([]),
        },
        heading: {
            type: String,
            default: '',
        },
        hasSeoOnly: {
            type: Boolean,
            default: false,
        },
        headingTag: {
            type: String,
            default: 'h2',
        },
        hasJsonLd: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        jsonLD () {
            if (!this.hasJsonLd) {
                return JSON.stringify({});
            }
            const schema = {
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: [],
            };
            this.items.forEach(item => {
                schema.mainEntity.push({
                    '@type': 'Question',
                    name: item.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: item.answer,
                    },
                });
            });
            return JSON.stringify(schema);
        },
    },
};
</script>

<style lang="scss" scoped>
.faq {
    padding: 60px 0 40px;
}
</style>
